//@ts-check
import { Box, makeStyles } from '@material-ui/core';
import { DatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import { getTime, isBefore, startOfDay } from 'date-fns';
import { useFormikContext } from 'formik';
import React from 'react';

import { resolve } from '../../../utils';

const useStyles = makeStyles(() => ({
    label: {
        color: '#3e4555',
        fontFamily: 'Gotham',
        fontSize: 14,
        fontWeight: 'bold',
    },
    picker: {
        display: 'block',
    },
    input: {
        color: '#3e4555',
        fontFamily: 'Gotham SSm A',
        fontSize: 14,
    },
}));

const FormDateField = ({ name = '', label, type = 'date', ...props }) => {
    const form = useFormikContext();
    const classes = useStyles();

    const value = resolve(name, form.values);
    const error = resolve(name, form.errors);

    return (
        <Box>
            <label htmlFor={name} className={classes.label}>
                {label}
            </label>
            {type === 'month' ? (
                <DatePicker
                    className={classes.picker}
                    views={['month', 'year']}
                    inputVariant="outlined"
                    size="small"
                    value={value}
                    error={Boolean(error)}
                    onChange={date => {
                        form.setFieldValue(name, getTime(date), false);
                    }}
                    InputProps={{ className: classes.input }}
                    minDateMessage="Date can't be in the past"
                    {...props}
                />
            ) : (
                <KeyboardDateTimePicker
                    className={classes.picker}
                    inputVariant="outlined"
                    size="small"
                    ampm={false}
                    value={value}
                    error={Boolean(error)}
                    onChange={date => form.setFieldValue(name, getTime(date), false)}
                    format="dd/MM/yyyy HH:mm"
                    InputProps={{ className: classes.input }}
                    shouldDisableDate={date => {
                        const startOfToday = startOfDay(new Date());
                        return isBefore(date, startOfToday);
                    }}
                    {...props}
                />
            )}
        </Box>
    );
};

export default FormDateField;
